import React from 'react';
import { IParentComponent } from '../../interfaces/IParentComponent';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';
import classNames from 'classnames';

export const ErrorBanner: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames(
        'rounded border-2 border-solid border-red-700 bg-red-200 p-4 text-center text-red-600',
        className
      )}
      data-test-id={mergeTests(rest['data-test-id'], 'error-banner-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'error-banner-tw')}
      {...rest}
    >
      {children}
    </div>
  );
};
